module.exports = __webpack_public_path__ + "img/tree_layer_4.ed135a82.png";